import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import { Box, Button, Typography } from "@mui/material";
import {
  statusColors,
  statusPanelSx,
  statusSectionTitleSx,
} from "../statusStyles";
import { formatMoney } from "../formatters";
import type { ClaimExchange, ClaimTranslator } from "../types";

type ExchangePaymentPanelProps = {
  exchange?: ClaimExchange | null;
  t: ClaimTranslator;
};

export const ExchangePaymentPanel = ({
  exchange,
  t,
}: ExchangePaymentPanelProps) => {
  if (!exchange?.payment_url) {
    return null;
  }
  const amount =
    formatMoney(
      Number(exchange.net_difference ?? 0),
      exchange.currency || undefined,
    ) ?? "";

  return (
    <Box mb="16px" sx={statusPanelSx(true)}>
      <Typography sx={{ ...statusSectionTitleSx, mb: "8px" }}>
        {t("status.exchangePayment.title")}
      </Typography>
      <Typography fontSize="14px" color={statusColors.bodyText} mb="12px">
        {t("status.exchangePayment.instructions", { amount })}
      </Typography>
      <Button
        variant="contained"
        href={exchange.payment_url}
        startIcon={<PaymentOutlinedIcon />}
      >
        {t("status.exchangePayment.pay", { amount })}
      </Button>
    </Box>
  );
};
